export default function WhyAlexeySivko() {
  const advantages = [
    { icon: 'ri-file-settings-line', title: 'Не шаблонные программы', desc: 'Каждая программа разрабатывается под конкретную компанию. Никаких типовых решений и универсальных скриптов.' },
    { icon: 'ri-search-eye-line', title: 'Предварительный аудит', desc: 'Перед тренингом провожу диагностику: слушаю звонки, читаю переписки, анализирую воронку и KPI.' },
    { icon: 'ri-user-star-line', title: 'Личный опыт продаж', desc: '18+ лет в продажах и переговорах. Знаю специфику изнутри: от холодного звонка до закрытия крупной сделки.' },
    { icon: 'ri-phone-find-line', title: 'Разбор реальных звонков', desc: 'На тренинге разбираем не абстрактные примеры, а звонки и переписки ваших сотрудников.' },
    { icon: 'ri-road-map-line', title: 'Работа «в поле»', desc: 'При необходимости выхожу на встречи вместе с менеджерами. Показываю, а не рассказываю.' },
    { icon: 'ri-24-hours-line', title: 'Сопровождение 24/7', desc: 'После тренинга сотрудники могут обратиться с вопросом в любой момент. Не бросаю после обучения.' },
    { icon: 'ri-book-read-line', title: 'Создание книги продаж', desc: 'По итогам проекта формирую документ со стандартами, скриптами, чек-листами и регламентами.' },
    { icon: 'ri-gamepad-line', title: 'Авторские бизнес-игры', desc: 'Разработал уникальные игровые механики для отработки навыков продаж и переговоров.' },
    { icon: 'ri-briefcase-line', title: 'Практикующий консультант', desc: 'Не академический теоретик. Постоянно работаю с реальными бизнесами и знаю текущую ситуацию рынка.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему выбирают Алексея Сивко для <strong>обучения отдела продаж</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            На рынке много бизнес-тренеров. Вот что отличает мой подход и почему компании возвращаются за повторными проектами.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {advantages.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}